import styled from "@emotion/styled";
import { Switch, switchClasses } from "@mui/base/Switch";

export const SwitchWrapper = styled.span`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
`;

export const SwitchStyled = styled(Switch)`
  position: relative;

  display: inline-block;

  /* the container style */
  &.${switchClasses.root} {
    inline-size: 37px;
    block-size: 24px;
  }

  /* the input element style */
  & .${switchClasses.input} {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
    z-index: 1;

    inline-size: 100%;
    block-size: 100%;
    margin: 0;

    cursor: pointer;

    opacity: 0;
  }

  & .${switchClasses.track} {
    position: absolute;

    display: block;

    inline-size: 100%;
    block-size: 100%;

    border-radius: 12px;

    background-color: #cccccc;
  }

  & .${switchClasses.thumb} {
    position: absolute;
    inset-block-start: 2px;
    inset-inline-start: 2px;

    display: block;

    inline-size: 20px;
    block-size: 20px;

    border-radius: 10px;

    background-color: #ffffff;

    transition: all 0.2s ease;
  }

  &.${switchClasses.checked} {
    .${switchClasses.track} {
      background-color: #4585ff;
    }
    .${switchClasses.thumb} {
      inset-block-start: 2px;
      inset-inline-start: 15px;
    }
  }

  &.${switchClasses.disabled} {
    opacity: 0.4;

    .${switchClasses.input} {
      cursor: not-allowed;
    }
  }
`;
